import React from 'react';

class CorrigirMovimentacaoConf extends React.Component {

    data(dt) {

        let vec = dt.split("-");
        let dia = vec[2];
        let mes = vec[1];
        let ano = vec[0];

        return dia + " / " + mes + " / " + ano;

    }

    ghg(g) {
        if (g) return "Sim";
        else return "Não";
    }

    render() {
        return(
            <div>
                <p id="corrmovimentacao-conf-alerta">
                    Após a correção, não será possível editar as informações da movimentação 
                    <br />financeira. Verifique estas informações antes de confirmar a correção.
                </p><br /><br />
                <p Style={ "font-family: 'Arial'; font-size: 16px; color: #666666;" }>
                    <b>Legenda</b>: 
                </p>
                <table Style={ "margin-top: 5px; border-collapse: collapse; width: 650px; font-family: 'Arial'; font-size: 16px; color: #666666;" }>
                    <tbody>
                        <tr Style={ "height: 25px;" }>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px;" }>
                                Correto
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ddeeff;" }>
                                Editado
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ffff00;" }>
                                Erro Simples
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ffff00; color: #ff0000;" }>
                                Erro Grave
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ff6666; color: #ffffff;" }>
                                Modificado após a aprovação/correção
                            </td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <table id="corrmovimentacao-conf-tbl">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Cadastrado</th>
                            <th>Corrigido</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrGhg }>
                                <b>GHG:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrGhg }>
                                <span>{ this.ghg(this.props.ghg) }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errGhg !== 0 && this.props.errGhg !== 3)
                                        && this.ghg(this.props.corrGhg) }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrData }>
                                <b>Data:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrData }>
                                <span>{ this.data(this.props.data) }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errData !== 0 && this.props.errData !== 3)
                                        && this.data(this.props.corrData) }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrBanco }>
                                <b>Banco:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrBanco }>
                                <span>{ this.props.bancos[this.props.banco] }</span>
                            </td>
                            <td><span>{ this.props.bancos[this.props.corrBanco] }</span></td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrContaId }>
                                <b>Conta:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrContaId }>
                                <span>{  this.props.conta }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errConta !== 0 && this.props.errConta !== 3) &&
                                        this.props.contas[this.props.corrConta].conta }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrContaId }>
                                <b>Código da Conta:</b></td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrContaId }>
                                <span>{ this.props.codConta }</span>
                            </td>
                            <td><span>{ this.props.corrCodConta }</span></td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrContaId }>
                                <b>Código da Movimentação:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrContaId }>
                                <span>{ this.props.codMovimentacao }</span>
                            </td>
                            <td><span>{ this.props.corrCodMovimentacao }</span></td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrHistorico }>
                                <b>Histórico:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrHistorico }>
                                <span>{ this.props.historico }</span>
                            </td>
                            <td><span>{ this.props.corrHistorico }</span></td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrDescricao }>
                                <b>Descrição da Movimentação:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrDescricao }>
                                <span>{ this.props.descricao }</span>
                            </td>
                            <td><span>{ this.props.corrDescricao }</span></td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrValor }>
                                <b>Valor:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrValor }>
                                <span>{ this.props.valor !== "" && "R$ " } { this.props.valor }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errValor !== 0 && this.props.errValor !== 3)
                                        && "R$ " + this.props.corrValor }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrNotaFiscal }>
                                <b>Documento Fiscal:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrNotaFiscal }>
                                <span>{ this.props.notaFiscal }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errNotaFiscal !== 0 && this.props.vErrNotaFiscal !== 3)
                                        && this.props.corrNotaFiscal.name }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrComprovante }>
                                <b>Comprovante de Pagamento:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrComprovante }>
                                <span>{ this.props.comprovante }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errComprovante !== 0 && this.props.errComprovante !== 3)
                                        && this.props.corrComprovante.name }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "corrmov-td-corr-" + this.props.vErrAnaliseContabil }>
                                <b>Análise Contábil:</b>
                            </td>
                            <td className={ "corrmov-td-corr-" + this.props.vErrAnaliseContabil }>
                                <span>{ this.props.analiseContabil }</span>
                            </td>
                            <td><span>{ this.props.corrAnaliseContabil }</span></td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <form id="corrmovimentacao-conf-form">
                    <button type="button" id="corrmovimentacao-voltar-btn" onClick={ this.props.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="corrmovimentacao-confirmar-btn"
                        onClick={ this.props.confirmar }
                        disabled={ this.props.disabled }>
                        Confirmar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default CorrigirMovimentacaoConf;

